/**
 * Macro-aware JSON editor that wires workflow variables and macro catalog
 * into the generic JsonCodeEditor from @chatsdet/ui.
 *
 * @module node-config/json-editor/MacroJsonEditor
 */

import React, { useMemo } from 'react';
import { JsonCodeEditor, type JsonCodeEditorProps, type CMTokenPattern } from '@chatsdet/ui';
import { MACRO_PATTERN, VARIABLE_PATTERN } from '@chatsdet/types';
import { useWorkflowVariablesContext } from '../../../pages/FlowDesigner/context/WorkflowVariablesContext';
import { buildCompletionEntries } from './macroCompletion';

/** Step reference pattern: {{step1.response.data.id}} */
const STEP_REF_PATTERN = /\{\{[^}]+\}\}/g;

const TOKEN_PATTERNS: CMTokenPattern[] = [
  { regex: MACRO_PATTERN, className: 'cm-macro-token' },
  { regex: VARIABLE_PATTERN, className: 'cm-variable-token' },
  { regex: STEP_REF_PATTERN, className: 'cm-step-ref-token' },
];

type MacroJsonEditorProps = Omit<
  JsonCodeEditorProps,
  'tokenPatterns' | 'completionEntries' | 'completionTrigger'
>;

export const MacroJsonEditor: React.FC<MacroJsonEditorProps> = (props) => {
  const variables = useWorkflowVariablesContext();

  const completionEntries = useMemo(
    () => buildCompletionEntries(variables),
    [variables]
  );

  return (
    <JsonCodeEditor
      {...props}
      tokenPatterns={TOKEN_PATTERNS}
      completionEntries={completionEntries}
      completionTrigger="$"
    />
  );
};
